import Vue from 'vue'
import Private from '../helper/Private'
import selectPublic from '../helper/selectPublic'
import * as $filter from '../helper/filter'
import * as $util from '../helper/util'

import md5 from 'js-md5'
Vue.prototype.$md5 = md5
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$bus = new Vue() 
Vue.prototype.$filter = $filter
Vue.prototype.$util = $util
Vue.prototype.$selectPublic = selectPublic
Vue.prototype.$Private = Private

